import React, { useRef, useEffect } from "react";
import Comenta from "../../comentario2026/comenta/Comenta";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal2 from "../../../components/modalsus2026/ModalSus";

const Contacto = () => {
    const [t, i18n] = useTranslation("home");
    const [popup, setPopup] = useState(false);
    

    const isMobile = useRef(false);
    const [sectionCss, setSectionCss] = useState({});

    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const openModal2 = () => {


        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Biblioteca',
            event_label: label,
            value: 1
        });
    };

    useEffect(() => {
        const width = window?.innerWidth;
        if (width <= 820) {
            isMobile.current = true;
        } else {
            isMobile.current = false;
        }
    }, []);

    useEffect(() => {
        if (!isMobile.current) return;
        console.log("👽 Cambio popup ", popup);
        if (popup) {
            setSectionCss({
                height: "550px",
            });
        } else {
            setSectionCss({});
        }
    }, [popup]);

    return (
        <div class="_nghost-ng-c2644841885">
            <section aria-label="Contacto y suscripcion" class="home-cta">
                <article class="home-cta__card home-cta__card--contact">
                    <div class="home-cta__content">
                        <h3 class="home-cta__title">{t("2026.quiero")}</h3>
                        <p class="home-cta__summary" dangerouslySetInnerHTML={{ __html: t("2026.mundo") }}></p><button onClick={(e) => {
                                e.preventDefault();
                                trackAnalyticsClick('Biblioteca - Contacto');
                                setPopup(true);
                            }} type="button" class="home-cta__button">{t("2026.escribeme")}</button>
                    </div>
                    <div aria-hidden="true" class="home-cta__image-wrap">
                        <img src="/assets/img2026/biblioteca_small_banner.png" alt="Escribeme" loading="lazy" width="880"
                            height="1138" />
                    </div>
                </article>
                <article class="home-cta__card home-cta__card--newsletter">
                    <h3 class="home-cta__newsletter-title">{t("2026.novedades")}</h3><button type="button" class="home-cta__button" onClick={() => {openModal2(); trackAnalyticsClick('Biblioteca - Suscribete');}}> {t("2026.suscribete")}
                    </button>
                </article>

            </section>
            {popup && (
                <div className="_ngcontent-ng-c2644841885 _nghost-ng-c2818847426">
                    <Comenta popup={popup} setPopup={setPopup} />
                </div>
            )}
            <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
        </div>
    );
};

export default Contacto;
